// extracted by mini-css-extract-plugin
export default {"textContainer":"TextInput_textContainer__E7R3c","textInput":"TextInput_textInput__Jm3TD"};